import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesNoRecibidoEnDestino() {
  return (
    <ClipperPlaceholder title="No Recibido en Destino" category="Novedades" />
  );
}
